import ISpineAnimConfig from '../../vendor_core/core/src/managers/contracts/configurations/spine_anim/ISpineAnimConfig';
import AbstractBaseSpineAnimationsConfig from '../../vendor_core/core/src/baseConfigs/AbstractSceneSpineAnimationsConfig';
import ISceneSpineAnimConfig from '../../vendor_core/core/src/managers/contracts/configurations/ISceneSpineAnimConfig';

class SpineAnimationsConfig extends AbstractBaseSpineAnimationsConfig implements ISceneSpineAnimConfig {
    anims: ISpineAnimConfig[] = [
        {
            name: "balloon_wild",
            hasSkins: false,
            states: [
                {
                    name: "animation",
                    loop: false,
                },
                {
                    name: "animation",
                    loop: false,
                },
                {
                    name: "BIG_WIN",
                    loop: false,
                },
                {
                    name: "HUGE_WIN",
                    loop: false,
                },
                {
                    name: "MEGA_WIN",
                    loop: false,
                },
                {
                    name: "ELECTRIC_WIN",
                    loop: false,
                },
                {
                    name: "Win-full-anim",
                    loop: false,
                },
            ],
            visible: true,
            defaultState: "BIG_WIN-4",
            playDefault: false,
            forceRepositionContainer: false,
        },
        {
            name: "bigwin_anim",
            hasSkins: false,
            states: [
                {
                    name: "animation",
                    loop: false
                },
                {
                    name: "BIG_WIN",
                    loop: true
                },
                {
                    name: "HUGE_WIN",
                    loop: true
                },
                {
                    name: "MEGA_WIN",
                    loop: true
                },
                {
                    name: "ELECTRIC_WIN",
                    loop: true
                },
            ],
            visible: false,
            containerSize: 1.2,
            defaultState: "MEGA_WIN",
            playDefault: false,
            forceRepositionContainer: false,
        },
        {
            name: "logo",
            hasSkins: false,
            states: [
                {
                    name: "win",
                    loop: false,
                },
                {
                    name: "beat",
                    loop: false,
                },
                {
                    name: "idle",
                    loop: true,
                },
            ],
            containerSize: 1.2,
            visible: true,
            defaultState: "idle",
            playDefault: true,
            forceRepositionContainer: false,
        },
        {
            name: "bg",
            hasSkins: false,
            states: [
                {
                    name: "main",
                    loop: true
                },
                {
                    name: "night",
                    loop: true
                },
                {
                    name: "sunset",
                    loop: true
                },
            ],
            visible: true,
            defaultState: "main",
            playDefault: true,
            forceRepositionContainer: false,
        },
        {
            name: "lightning",
            hasSkins: false,
            states: [
                {
                    name: "lightning_strike",
                    loop: false
                },
                {
                    name: "single_shot",
                    loop: false
                },
            ],
            visible: false,
            forceRepositionContainer: false,
        },
        {
            name: "anticipation",
            hasSkins: false,
            states: [
                {
                    name: "1",
                    loop: true
                },
                {
                    name: "2",
                    loop: true
                },
                {
                    name: "3",
                    loop: true
                },
                {
                    name: "4",
                    loop: true
                },
                {
                    name: "5",
                    loop: true
                },
                {
                    name: "6",
                    loop: true
                },
                {
                    name: "7",
                    loop: true
                },
                {
                    name: "8",
                    loop: true
                },
            ],
            visible: false,
            forceRepositionContainer: false,
        },
        {
            name: "multiplier_ui",
            hasSkins: false,
            states: [
                {
                    name: "multiplier_idle",
                    loop: false
                },
                {
                    name: "multiplier_ui_change",
                    loop: false
                },
            ],
            visible: false,
            forceRepositionContainer: false,
        },
        {
            name: "tornado",
            hasSkins: false,
            states: [
                {
                    name: "tornado",
                    loop: false
                }
            ],
            visible: true,
            playDefault: true,
            defaultState: "tornado",
            forceRepositionContainer: false,
        },
        {
            name: "glow_anim",
            hasSkins: false,
            states: [
                {
                    name: "glow_anim",
                    loop: false,
                    timeScale: 0.85
                },
                {
                    name: "glow_1",
                    loop: false,
                },
                {
                    name: "glow_2",
                    loop: false,
                },
                {
                    name: "glow_3",
                    loop: false,
                },
                {
                    name: "glow_4",
                    loop: false,
                },
            ],
            visible: true,
            playDefault: true,
            defaultState: "glow_anim",
            forceRepositionContainer: false,
        },
        {
            name: "popup_win",
            states: [
                {
                    name: "intro",
                    loop: false
                },
                {
                    name: "idle_big_win",
                    loop: true
                },
                {
                    name: "big_to_mega",
                    loop: false
                },
                {
                    name: "idle_mega_win",
                    loop: true
                },
                {
                    name: "mega_to_huge",
                    loop: false
                },
                {
                    name: "idle_huge_win",
                    loop: true
                },
                {
                    name: "huge_to_electric",
                    loop: false
                },
                {
                    name: "idle_electric_win",
                    loop: true
                },
                {
                    name: "outro_big_win",
                    loop: false
                },
                {
                    name: "outro_electric_win",
                    loop: false
                },
                {
                    name: "outro_huge_win",
                    loop: false
                },
                {
                    name: "outro_mega_win",
                    loop: false
                },
            ],
            hasSkins: false,
            visible: true,
            forceRepositionContainer: false,
            chainingStates: [
                {
                    name: "big_win",
                    states: ["intro", "idle_big_win"],
                    entryPoint: "intro",
                    loop: false,
                    hideOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hasLoopStateOnComplete: true,
                    loopStateOnComplete: "idle_big_win"
                },
                {
                    name: "feature_bye",
                    states: ["intro", "idle_electric_win"],
                    entryPoint: "intro",
                    loop: false,
                    hideOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hasLoopStateOnComplete: true,
                    loopStateOnComplete: "idle_electric_win"
                },
                {
                    name: "mega_win",
                    states: ["big_to_mega", "idle_mega_win"],
                    entryPoint: "big_to_mega",
                    loop: false,
                    hideOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hasLoopStateOnComplete: true,
                    loopStateOnComplete: "idle_mega_win",
                },
                {
                    name: "huge_win",
                    states: ["mega_to_huge", "idle_huge_win"],
                    entryPoint: "idle_huge_win",
                    loop: false,
                    hideOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hasLoopStateOnComplete: true,
                    loopStateOnComplete: "idle_huge_win",
                },
                {
                    name: "electric_win",
                    states: ["huge_to_electric", "idle_electric_win"],
                    entryPoint: "huge_to_electric",
                    loop: false,
                    hideOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hasLoopStateOnComplete: true,
                    loopStateOnComplete: "idle_electric_win",
                },
            ],
            defaultState: "big_win",
            playDefault: true,
        },
    ];
}

export default new SpineAnimationsConfig()
